<template>
  <div class="component-form-registration">
    <div class="title title-form title-success text-center"><strong>CADASTRE-SE</strong></div>
    <div class="space-20"></div>
    <form v-on:submit.prevent="doRegistration()" class="form-register" novalidate>
      <input-text placeholder="Como gostaria de ser chamado?" name="name" v-model="name" :error="errors.name"/>
      <input-email placeholder="E-mail" name="email" v-model="email" :error="errors.email"/>
      <div class="row">
        <div class="col-sm-6">
          <input-password placeholder="Senha" name="password" v-model="password" :error="errors.password"/>
        </div>
        <div class="col-sm-6">
          <input-password placeholder="Confirme a senha" name="password_confirmation" v-model="passwordConfirmation" :error="errors.password_confirmation"/>
        </div>
      </div>
      <div class="space-10"></div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group" v-bind:class="{ 'has-error': errors.terms && !terms}">
            <div class="checkbox">
              <label> 
                <input type="checkbox" name="terms" v-model="terms"> <label class="mr-15">Lí e aceito</label> 
                <router-link :to="{ name: 'use_terms' }" target="_blank">termos de uso</router-link> e as
                <router-link :to="{ name: 'privacy_policy' }" target="_blank">políticas de privacidade</router-link>.
              </label>
            </div>
            <span v-if="errors.terms && !terms" class="help-block text-left" v-html="errors.terms"></span>
          </div>
        </div>
      </div>

      <div class="space-15"></div>
      <div class="form-group text-center">
        <button v-bind:disabled="loading" class="btn btn-success bold" type="submit" >
          CADASTRAR
          <transition name="fade" mode="out-in">
            <span v-if="loading"><i class="fa fa-fw fa-lg fa-spinner fa-spin"></i></span>
          </transition>
        </button>
      </div>


    </form>

  </div>
</template>

<script>
  import * as config from '../../config.js'
  import * as env from '../../env'
  import {mapState, mapActions} from 'vuex'

  export default{
    name: 'FormRegistration',
    components: {},
    props: [],
    data () {
      return {
        name: '',
        email: '',
        password: '',
        passwordConfirmation: '',
        errors: false,
        loading: false,
        terms: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    methods: {
      doRegistration () {
        this.errors = {}
        let error = false
        if (this.name === '') {
          this.$set(this.errors, 'name', 'O nome é obrigatório')
          window.$('input[name=name]', this.$el).focus()
          error = true
        }
        if (this.email === '') {
          this.$set(this.errors, 'email', 'O e-mail é obrigatório')
          if (!error) window.$('input[name=email]', this.$el).focus()
          error = true
        }
        if (this.password === '') {
          this.$set(this.errors, 'password', 'A senha é obrigatória')
          if (!error) window.$('input[name=password]', this.$el).focus()
          error = true
        }
        if (this.passwordConfirmation === '' || (this.passwordConfirmation !== '' && this.passwordConfirmation !== this.password)) {
          let message = 'A confirmação da senha é obrigatória'
          if (this.passwordConfirmation !== '') {
            message = 'A confirmação da senha está diferente'
          }
          this.$set(this.errors, 'password_confirmation', message)
          if (!error) window.$('input[name=password_confirmation]', this.$el).focus()
          error = true
        }
        if (!this.terms) {
          this.errors.terms = 'É necessário aceitar os termos de uso e de privacidade.'
          if (!error) window.$('input[name=terms]', this.$el).focus()
          error = true
        }
        if (error) return

        this.loading = true
        const postData = {
          name: this.name,
          email: this.email,
          password: this.password,
          password_confirmation: this.passwordConfirmation
        }
        const loginData = {
          grant_type: 'password',
          client_id: env.clientId,
          client_secret: env.clientSecret,
          username: this.email,
          password: this.password,
          scope: ''
        }
        this.$http.post(config.usersURL, postData)
          .then(response => {
            this.$http.post(config.loginURL, loginData)
              .then(response => {
                this.saveUser(response.data)
                this.$http.get(config.userURL)
                .then(response => {
                  this.saveUser(response.data)
                  this.$emit('registered', response.data)
                  this.loading = false
                })
              })
          }, error => {
            this.loading = false
            if (error.data.error === 'Validation error') {
              this.errors = error.data.errors
            }
            window.$('input[name=' + Object.keys(this.errors)[0] + ']', this.$el).focus()
          })
      },
      ...mapActions(['saveUser'])
    }
  }
</script>

<style scoped>
.mr-15 {
  margin-left:-15px;
}
</style>



// WEBPACK FOOTER //
// FormRegistration.vue?c6d6ea96